// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"65":"5cc897f6","345":"384cddc7"}[chunkId] + ".chunk.js";
};